/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Default_Pattern_Edit_ErrorInputs */



/**
* | output |
* | --- |
* | "Default patterns cannot be edited" |
*
* @param {Compliance_Default_Pattern_Edit_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_default_pattern_edit_error = /** @type {((inputs?: Compliance_Default_Pattern_Edit_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Default_Pattern_Edit_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmuster können nicht bearbeitet werden")
	return /** @type {LocalizedString} */ ("Default patterns cannot be edited")
});